RESET_ACCOUNT_CHANGE_PLAN_DATA